import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    DetailsBtns,
    DetailsHeading,
    Flex,
    H1,
    SmallSpacing,
    Tr, Table, Th, Td, ListHeading, CreateBtn, H3, InlineLink
} from "../../styles";
import useAdminStatus from "../hooks/useAdminStatus";

const CourseDetail = ({ user }) => {
    const { id } = useParams();
    const [course, setCourse] = useState(null);
    const { isAdmin } = useAdminStatus();

    useEffect(() => {
        axios.get(`/course/${id}/`)
            .then(response => {
                console.log("Course data:", response.data); // Log the response
                setCourse(response.data);
            })
            .catch(error => console.error("There was an error fetching the course data!", error));
    }, [id]);

    if (!course) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <ListHeading>
                <H1>{course.name} - {course.code}</H1>
                {isAdmin && (
                <Flex>
                        <InlineLink>
                            <Link to={`/courses/update/${course.id}`}>Update Course</Link>
                        </InlineLink>
                        <SmallSpacing/>
                        <InlineLink>
                            <Link to={`/courses/delete/${course.id}`}>Delete Course</Link>
                        </InlineLink>
                    </Flex>)}
            </ListHeading>
            {course.classes && course.classes.length > 0 ? (
                <>
                    <ListHeading>
                        <H3>Timetable:</H3>
                        {isAdmin && (
                            <CreateBtn>
                                <Link to="/class/create">Add Class</Link>
                            </CreateBtn>)}
                    </ListHeading>
                    <Table>
                        <Tr>
                            <Th>Class Number</Th>
                            <Th>Semester</Th>
                            <Th>Year</Th>
                            <Th>Class Lecturer</Th>
                            <DetailsHeading>Details</DetailsHeading>
                        </Tr>
                        {course.classes.map(courseClass => (
                            <Tr key={courseClass.id}>
                                <Td>{courseClass.number}</Td>
                                <Td>Semester {courseClass.semester_details.semester}</Td>
                                <Td>{courseClass.semester_details.year}</Td>
                                <Td>{courseClass.lecturer_details.first_name} {courseClass.lecturer_details.last_name}</Td>
                                <DetailsBtns>
                                    <Flex>
                                        <Link to={`/class/${courseClass.id}`}>View</Link>
                                        <SmallSpacing />
                                        {isAdmin && (
                                            <>
                                                <Link to={`/class/update/${courseClass.id}`}>Update</Link>
                                                <SmallSpacing />
                                                <Link to={`/class/delete/${courseClass.id}`}>Delete</Link>
                                            </>)}
                                    </Flex>
                                </DetailsBtns>
                            </Tr>
                        ))}
                    </Table>
                </>
            ) : (
                <p>No classes in this course yet.
                    {isAdmin && (
                        <Link to="/class/create">Add Class</Link>)}
                </p>
            )}
        </Container>
    );
};

export default CourseDetail;
